import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=0effe40e&scoped=true&"
import script from "./Form.ts?vue&type=script&lang=ts&"
export * from "./Form.ts?vue&type=script&lang=ts&"
import style0 from "./Form.vue?vue&type=style&index=0&id=0effe40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effe40e",
  null
  
)

export default component.exports